import { useEffect } from 'react';
import { SHOW_DEPRECATION_WARNINGS } from '@bubble-dev/build-config';
var useDeprecationWarning = _ref => {
  var {
    componentName,
    useInstead,
    removalDate,
    readMore
  } = _ref;
  useEffect(() => {
    if (SHOW_DEPRECATION_WARNINGS) {
      var deprecationWarning = "BUBBLE-UI DEPRECATION WARNING: '".concat(componentName, "' is deprecated and will be removed");
      if (removalDate) {
        deprecationWarning += " in/by ".concat(removalDate);
      }
      deprecationWarning += ".";
      if (useInstead) {
        deprecationWarning += "\nUse '".concat(useInstead, "' instead.");
      }
      if (readMore) {
        deprecationWarning += "\nRead more on ".concat(readMore);
      }
      console.warn(deprecationWarning);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
export default useDeprecationWarning;
//# sourceMappingURL=index.js.map